import axios from "axios"

export function isTouchEnabled() {
	return ('ontouchstart' in window) ||
		(navigator.maxTouchPoints > 0) ||
		(navigator.msMaxTouchPoints > 0)
}

export function showK1Loader() {
	kendo.ui.progress($(document.body), true);
}

export function hideK1Loader() {
	kendo.ui.progress($(document.body), false);
}

export function appUrl(app) {
	return window.appLinks[app];
}

export function jqGet(url, callback) {
	$.ajax({
		url: url,
		method: 'GET',
		xhrFields: {
			withCredentials: true
		},
		success: callback
	});
}

export function jqGetJson(url, callback) {
	$.ajax({
		dataType: 'json',
		url: url,
		xhrFields: {
			withCredentials: true
		},
		success: callback
	});
}

export function jqPost(url, data, callback) {
	$.ajax({
		url: url,
		method: 'POST',
		xhrFields: {
			withCredentials: true
		},
		data: data,
		success: callback
	});
}

function showLoadingProgress() {
	kendo.ui.progress($(document.body), true);
}

function hideLoadingProgress() {
	kendo.ui.progress($(document.body), false);
}

window.hideLoadingProgress = hideLoadingProgress
window.showLoadingProgress = showLoadingProgress
window.isTouchEnabled = isTouchEnabled
window.showK1Loader = showK1Loader
window.hideK1Loader = hideK1Loader
window.jqGet = jqGet
window.jqGetJson = jqGetJson
window.jqPost = jqPost
window.axios = axios
